module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img72.cff721f4.jpg";